var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { action, makeObservable } from 'mobx';
import { API_PATH } from '../../../constants';
import { getAxios } from '../../../backend';
class PushNotificationsModule {
    constructor(notificationsStore) {
        Object.defineProperty(this, "notificationsStore", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "isNotificationSupported", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: () => 'Notification' in window && 'serviceWorker' in navigator && 'PushManager' in window
        });
        Object.defineProperty(this, "askNotificationPermission", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: () => __awaiter(this, void 0, void 0, function* () {
                if (this.isNotificationSupported()) {
                    const that = this;
                    if (Notification.permission === 'granted' && 'serviceWorker' in navigator) {
                        navigator.serviceWorker.ready.then(function (reg) {
                            reg.pushManager.getSubscription().then(function (sub) {
                                if (sub === null) {
                                    that.subscribeUser();
                                }
                                else {
                                    return;
                                }
                            });
                        });
                    }
                    else if (Notification.permission !== 'denied') {
                        Notification.requestPermission().then((permission) => {
                            if (permission === 'granted') {
                                this.subscribeUser();
                            }
                        });
                    }
                    else {
                        yield this.unsubscribeUser();
                    }
                }
            })
        });
        Object.defineProperty(this, "subscribeUser", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: () => __awaiter(this, void 0, void 0, function* () {
                const that = this;
                if ('serviceWorker' in navigator) {
                    yield navigator.serviceWorker.ready.then(function (reg) {
                        const { notifications } = that.notificationsStore.rootStore.settings.generalSettings;
                        if (notifications && notifications.publicKey) {
                            reg.pushManager
                                .subscribe({
                                userVisibleOnly: true,
                                applicationServerKey: that.urlBase64ToUint8Array(notifications.publicKey),
                            })
                                .then((sub) => __awaiter(this, void 0, void 0, function* () {
                                yield getAxios()
                                    .then((axios) => {
                                    return axios.post(`${API_PATH.NOTIFICATIONS}/subscribe`, {
                                        sub: sub,
                                    }, {
                                        headers: {
                                            'content-type': 'application/json',
                                        },
                                    });
                                })
                                    .catch((e) => {
                                    console.error(`Subscribe error ${e}`);
                                });
                                console.log('Endpoint URL: ', sub);
                            }))
                                .catch(function (e) {
                                if (Notification.permission === 'denied') {
                                    console.error('Permission for notifications was denied');
                                }
                                else {
                                    console.error('Unable to subscribe to push', e);
                                }
                            });
                        }
                        else {
                            console.error('No public key to subscribe for notifications!');
                        }
                    });
                }
                else {
                    console.log('NO SERVICE WORKER');
                }
            })
        });
        Object.defineProperty(this, "unsubscribeUser", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: () => __awaiter(this, void 0, void 0, function* () {
                const that = this;
                if ('serviceWorker' in navigator) {
                    yield navigator.serviceWorker.ready.then(function (reg) {
                        reg.pushManager.getSubscription().then(function (subscription) {
                            if (subscription !== null) {
                                subscription
                                    .unsubscribe()
                                    .then(() => __awaiter(this, void 0, void 0, function* () {
                                    yield getAxios()
                                        .then((axios) => {
                                        var _a;
                                        return axios.post(`${API_PATH.NOTIFICATIONS}/unsubscribe`, {
                                            sub: subscription,
                                            uid: (_a = that.notificationsStore.rootStore.loginStore.userDetails) === null || _a === void 0 ? void 0 : _a.uid,
                                        });
                                    })
                                        .catch((e) => {
                                        console.error(`Subscribe error ${e}`);
                                    });
                                }))
                                    .catch(function (e) {
                                    // Unsubscription failed
                                });
                            }
                        });
                    });
                }
            })
        });
        Object.defineProperty(this, "urlBase64ToUint8Array", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (base64String) => {
                const padding = '='.repeat((4 - (base64String.length % 4)) % 4);
                const base64 = (base64String + padding).replace(/\-/g, '+').replace(/_/g, '/');
                const rawData = window.atob(base64);
                const outputArray = new Uint8Array(rawData.length);
                for (let i = 0; i < rawData.length; ++i) {
                    outputArray[i] = rawData.charCodeAt(i);
                }
                return outputArray;
            }
        });
        makeObservable(this);
        this.notificationsStore = notificationsStore;
    }
}
__decorate([
    action
], PushNotificationsModule.prototype, "askNotificationPermission", void 0);
export default PushNotificationsModule;
